import React from 'react';
import classNames from 'classnames';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {PrimaryButton} from '@techsee/techsee-ui-common/lib/forms/buttons/primary';
import {observer, inject, IReactComponent} from 'mobx-react';
import {SimpleLabel} from '@techsee/techsee-ui-common/lib/forms/labels/simple';
import {IInvitationEndedStore} from './invitation-ended.stores';
import {IAppRootStore} from '../../app.root.store';

import './styles.scss';

interface InvitationEndedViewProps {
    invitationEndedStore: IInvitationEndedStore;
    rootStore: IAppRootStore;
}

@observer
export class InvitationEndedViewComponent extends TechseeBaseComponent<InvitationEndedViewProps> {
    renderInternal(): JSX.Element {
        const {invitationEndedStore} = this.props;
        const controller = invitationEndedStore.invitationEndedController;

        if (!controller) {
            return <div></div>;
        }

        return (
            <div className='invitation-ended-state'>
                <div className='logo'>
                    <img
                        className={
                            controller.warmTransferExpired && !controller.hasBrandingLogo() ? 'logo-img ts' : 'logo-img'
                        }
                        src={controller.logoImage}
                        alt='logo'
                    />
                </div>

                {controller.isSessionEnded && (
                    <div>
                        {controller.warmTransferExpired && (
                            <div>
                                <div className='labels-container'>
                                    <SimpleLabel className='primary-label'>
                                        {controller.wtSessionEndedMessages?.[0]}
                                    </SimpleLabel>
                                    <SimpleLabel className='secondary-label'>
                                        {controller.wtSessionEndedMessages?.[1]}
                                    </SimpleLabel>
                                </div>
                                <PrimaryButton className='back-to-invite-button' onClick={controller.goToInvitePage}>
                                    {controller.translate('REACT.INVITATION_ENDED.GO_TO_INVITE_PAGE')}
                                </PrimaryButton>
                            </div>
                        )}
                        {!controller.warmTransferExpired && (
                            <div
                                className={classNames('session-expired', {
                                    desktop: !controller.isPhone
                                })}
                                dangerouslySetInnerHTML={{__html: controller.sessionEndedMessage}}
                            />
                        )}
                    </div>
                )}

                <div className='powered-by'>{controller.translate('DASHBOARD.VIEW.POWERED_BY_TECHSEE')}</div>
            </div>
        );
    }
}

export const InvitationEndedView = inject(
    'rootStore',
    'invitationEndedStore'
)(InvitationEndedViewComponent) as IReactComponent;
